<template>
    <v-layout row wrap>
        <v-flex xs12 >
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Circuit Runtime for last 30 days
                </v-card-title>

                <v-layout row wrap>

                    <v-flex xs6 v-if="data" v-for="piedata in data">
                        <vue-plotly  :data="piedata"  :layout="{width:'100%'}" :options="{}" ref="plotly"/>
                    </v-flex>

                </v-layout>
            </v-card>
        </v-flex>





    </v-layout>
</template>

<script>
    import {callAPI} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import moment from 'moment'
    export default {
        name: 'Circuits',
        components: { VuePlotly},

        data () {
            return {
                range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
                data:null,
                options: {},
                layout:{

                }
            }
        },
        mounted() {
            let promises=[];
            let me=this;
            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                if(equip.equipment_type==='chiller'){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'M',
                            'agg_op': 'sum',
                            'date_range':[this.range.start,this.range.end],
                            'sensor_names': ['Average_Motor_Current_%_RLA_AFD_1A','Average_Motor_Current_%_RLA_AFD_2A']
                        }
                    ))
                }
            }
            Promise.all(promises).then(function(reses) {
                let data=[];
                for (let res of reses){
                    data.push([{
                        type:'pie',
                        title:JSON.parse(res.config.data)["equipment_name"],
                        labels:["Circuit 1","Circuit 2"],
                        values:[res.data['Average_Motor_Current_%_RLA_AFD_1A'][0],res.data['Average_Motor_Current_%_RLA_AFD_2A'][0]]
                    }])
                }
                me.data=data;
            });
        }


    }
</script>
